import { render, staticRenderFns } from "./deals-card.vue?vue&type=template&id=52c3d675"
import script from "./deals-card.vue?vue&type=script&lang=js"
export * from "./deals-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports